export default __webpack_public_path__ + "static/media/unass.2b334d20.jpg";